import { STATE_LOGIN, STATE_SIGNUP } from 'vortex/component/AuthForm';
import React from 'react';
import '../styles/reduction.scss';
import '../App.css';

import { EmptyLayout, LayoutRoute, MainLayout } from 'components/Layout';
import AppLayout from '../components/Layout/AppLayout/AppLayout';
import { BrowserRouter, HashRouter, Redirect, Route, Switch } from 'react-router-dom';
import PageSpinner from 'components/PageSpinner';
import componentQueries from 'react-component-queries';
import { Cookies } from 'react-cookie';

import QuickFormTask	from 	'./QuickFormTask'
import AuthPage from 'vortex/AuthPage';

const cookie =new Cookies();

var link = require('vortex/config/link.json');


const getBasename = () => {
    return `/${process.env.PUBLIC_URL.split('/').pop()}`;
  };
const getRestAPI = () => {
    return `${process.env.REACT_APP_REST_URL}`;
  };
  
  
class App extends React.Component{
    constructor(props){
        super(props);          
    }
    render(){
      if(cookie.get('v-email') != null){
            return(
            <>
              <HashRouter basename={getBasename()} >
                  <Switch>
                      <AppLayout breakpoint={this.props.breakpoint} id="main" >
                          <React.Suspense fallback={<PageSpinner />}>
                            <Route exact path="/login"   render={props => (<QuickFormTask  /> )} />
                            <Route exact path="/"   render={props => (<QuickFormTask  /> )} />
                          </React.Suspense>
                      </AppLayout>
                      <Redirect to={'/'} />
                  </Switch>
              </HashRouter>
            </>
          )
        }else{
          return(
            <HashRouter basename={getBasename()} >
                <Switch>
                    <LayoutRoute exact path="/login" layout={EmptyLayout} component={props => (<AuthPage {...props} authState={STATE_LOGIN} />)} />
                    <LayoutRoute exact path="/signup" layout={EmptyLayout} component={props => (<AuthPage {...props} authState={STATE_SIGNUP} />)} />
                    <LayoutRoute path="/" layout={EmptyLayout} component={props => (<AuthPage {...props} authState={STATE_LOGIN} />)} />  
                </Switch>
            </HashRouter>
          )
        }
    
    }
    getQueryString=(param)=>{
      var _result = "";
      var indexOfQuestionMark = window.location.href.indexOf('?');
      if(indexOfQuestionMark == -1)
        return _result;
      var queryString = window.location.href.substring(indexOfQuestionMark);
      var indexOfParam = queryString.indexOf(param + '=');
      var indexOfParamEnd = queryString.indexOf('&', indexOfParam);
      if(indexOfParamEnd==-1)
        _result = queryString.substring(indexOfParam + param.length +1);
      else
        _result = queryString.substring(indexOfParam + param.length +1, indexOfParamEnd);
    
      return _result;
    }
    
}

const query = ({ width }) => {
    if (width < 575) {
      return { breakpoint: 'xs' };
    }
  
    if (576 < width && width < 767) {
      return { breakpoint: 'sm' };
    }
  
    if (768 < width && width < 991) {
      return { breakpoint: 'md' };
    }
  
    if (992 < width && width < 1199) {
      return { breakpoint: 'lg' };
    }
  
    if (width > 1200) {
      return { breakpoint: 'xl' };
    }
  
    return { breakpoint: 'xs' };
};

export default componentQueries(query)(App);
  